"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "TestIdProvider", {
  enumerable: true,
  get: function () {
    return _TestIdProvider.default;
  }
});
Object.defineProperty(exports, "testIdContext", {
  enumerable: true,
  get: function () {
    return _testIdContext.default;
  }
});
var _TestIdProvider = _interopRequireDefault(require("./TestIdProvider"));
var _testIdContext = _interopRequireDefault(require("./testIdContext"));
//# sourceMappingURL=index.js.map